import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    SavedQueriesList,
    FilterLiveSearch,
    DeleteButton,
    DateField,
    TranslatableFields,
    ArrayField,
} from 'react-admin';
import { Card, CardContent } from '@mui/material';
import StandardListActions from './StandardListActions';

export const NotificationsFilterSidebar = () => (
    <Card sx={{ order: -1, mr: 2, mt: 6, width: 'max-content' }}>
        <CardContent>
            <SavedQueriesList />
            <FilterLiveSearch label='Username' source='username__ilike' variant='outlined' />
            <FilterLiveSearch label='Category' source='content.inApp.category__ilike' variant='outlined' />
            <FilterLiveSearch label='Django ID' source='djangoId' variant='outlined' type='number'/>
        </CardContent>
    </Card>
);

const NotificationsList = (props: any) => {
    return (
        <List {...props} aside={<NotificationsFilterSidebar />} actions={<StandardListActions />}>
            <Datagrid>
                <TextField source='content.inApp.category' label='Category' />
                <TranslatableFields locales={['en', 'es', 'pt']} defaultLocale='es'>
                    <TextField source='content.inApp.content' label='Content' />
                </TranslatableFields>
                <DateField source='createdAt' label='Created' />
                <DateField source='updatedAt' label='Updated' />
                <DateField source='status.inApp.readedOn' label='Readed On' />
                <TextField source='email' label='Email' />
                <TextField source='username' label='Username' />
                <TextField source='sender' label='Sender' />
                <TextField source='appIds' label='appIds' />
                <TextField source='countryIds' label='countryIds' />
                <TextField source='djangoId' label='Django ID' />
                <DeleteButton />
            </Datagrid>
        </List>
    );
};

export default NotificationsList;
